module.exports = __webpack_public_path__ + "static/image2-8e7164cfc3fcacaf32aa3ede8dff28b5.jpg";